import React, { useEffect, useRef } from "react";
import "./Hero.css";

const Hero = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const scrollToServices = () => {
    const element = document.getElementById("services");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="hero" ref={heroRef}>
      <div className="hero-background">
        <div className="grid-overlay"></div>
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>

      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            <span className="title-line">Future-Ready</span>
            <span className="title-line">Technology</span>
            <span className="title-line highlight">Solutions</span>
          </h1>
          <p className="hero-subtitle">
            Empowering businesses with cutting-edge Web, Android, Cloud, Data Analytics, AI/ML, and Blockchain solutions. Transform your digital presence today.
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={scrollToServices}>
              Explore Services
              <span className="btn-arrow">→</span>
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => {
                const element = document.getElementById("contact");
                if (element) element.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Get Started
            </button>
          </div>
        </div>

        <div className="hero-visual">
          <div className="tech-grid">
            <div className="tech-card">Web </div>
            <div className="tech-card">Android </div>
            <div className="tech-card">Cloud </div>
            <div className="tech-card">Data </div>
            <div className="tech-card">AI & ML</div>
            <div className="tech-card">Blockchain </div>
          </div>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <div className="arrow">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
